export default __webpack_public_path__ + "static/impact-ready-highlight-mobile-b37d1d71125ad33d4501a64c0fa506a3.svg";